export default {
    trainer: null,
};



// WEBPACK FOOTER //
// ./src/store/trainer/state.js